import type { FieldErrors } from 'react-hook-form';

export function getFieldError(errors: FieldErrors<any>, fieldName: string) {
  // Match the dynamic pattern: anyArray[index].property with an useFieldArray
  const match = fieldName?.match(/^(\w+)\.(\d+)\.(\w+)$/);
  if (match) {
    // arrayName = e.g. 'customers', index = '2', key = e.g. 'birthDate'
    const [, arrayName, index, key] = match;
    return errors?.[arrayName!]?.[index!]?.[key];
  }

  // Otherwise return the error for the field
  return errors[fieldName];
}
